import { MODEL_LABS } from './catalog.js';
const LABS_BY_ID = new Map(MODEL_LABS.map((lab) => [lab.id, lab]));
export function findModelLab(id) {
    return id ? (LABS_BY_ID.get(id) ?? null) : null;
}
/** Resolves the public URL for a lab mark in the active theme. */
export function modelLabLogoUrl(lab, mode) {
    return `/logos/${mode === 'dark' ? lab.dark : lab.light}`;
}
//# sourceMappingURL=lookup.js.map